import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";

export const FONT_THEME = {
  "@font-face": [
    {
      fontFamily: "Cocon",
      src: `url('${generateFrontPath({
        id: "@front.internal-assets",
        parameters: {
          filePath: "fonts/Cocon Light.otf",
        },
        includeBasePath: true,
      })}') format('truetype')`,
      fontWeight: 300,
      fontStyle: "normal",
    },
  ],
};
